import request from '@/utils/request'

//绑定分组
export function dataBind(params) {
  return request({
    url: '/member/business/data/bind',
    method: 'put',
    data: params
  })
}

//查询客户池分组
export function groupList() {
  return request({
    url: '/member/business/data/group/list',
    method: 'get'
  })
}

//增加客户池分组
export function groupCreate(params) {
  return request({
    url: '/member/business/data/group/create',
    method: 'post',
    data: params
  })
}

//删除客户池分组
export function groupDelete(id) {
  return request({
    url: '/member/business/data/group/delete?id=' + id,
    method: 'put'
  })
}

//解锁 改变为添加
export function butchUnlock(params) {
  return request({
    url: '/search/action/batch/syncBusinessData',
    method: 'post',
    data: params
  })
}
// export function butchUnlock(params) {
//   return request({
//     url: '/search/action/batch/unlock',
//     method: 'post',
//     data: params
//   })
// }

// 解锁联系人
export function unlock(params) {
  return request({
    url: '/search/action/batch/unlock',
    method: 'post',
    data: params
  })
}

//获得客户池信息分页
export function dataPage(pageVO) {
  return request({
    url: '/member/business/data/page' + pageVO,
    method: 'get'
  })
}

//导出客户池信息 Excel
export function exportExcel(exportReqVO) {
  return request({
    url: '/member/business/data/export-excel?exportReqVO=' + exportReqVO,
    method: 'get'
  })
}

//创建人群包
export function createCrowd(params) {
  return request({
    url: '/search/action/create/crowd',
    method: 'post',
    data: params
  })
}

//获得人群包分组列表
export function crowdGroupList() {
  return request({
    url: '/member/business/group/list',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/customerPool.js